// 
import WebComponent from '../src/webComponents/WebComponent';

/**
 * password toggle - prepinani type = password | text
 *
 */
export default class PasswordToggle extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleVisibility = this.handleVisibility.bind(this);
  }

	didMount() {
    this.buildHtml();
    this.bindEvents();
	}

  buildHtml() {
    // create wrapper
    const wrapper = document.createElement('div');
    wrapper.classList.add('password-toggle', 'form-control-password-toggle-wrapper');

    this.element.parentNode.insertBefore(wrapper, this.element);
    wrapper.appendChild(this.element);

    // create ico handler
    this.icoHandler = document.createElement('span');
    this.icoHandler.classList.add('password-toggle__ico', 'ico-handler');

    this.element.parentNode.insertBefore(this.icoHandler, this.element.nextSibling);

    // create svg icon
    const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgIcon.classList.add('svg-icon');

    const svgLink = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    svgLink.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/build/img/svg/svg-sprite.svg#password-toggle');
    svgIcon.appendChild(svgLink);

    const svgIconActive = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgIconActive.classList.add('svg-icon','svg-icon--active');

    const svgLinkActive = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    svgLinkActive.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/build/img/svg/svg-sprite.svg#password-toggle-active');
    svgIconActive.appendChild(svgLinkActive);

    this.icoHandler.appendChild(svgIcon);
    this.icoHandler.appendChild(svgIconActive);
  };


  bindEvents() {
    this.icoHandler.addEventListener('click', this.handleClick);
    this.element.addEventListener('input', this.handleVisibility);

    this.handleVisibility();
  };

  willUnMount() {
    this.icoHandler.removeEventListener('click', this.handleClick);
    this.element.removeEventListener('input', this.handleVisibility);
  }

  handleClick() {
    const currentType = this.element.getAttribute('type');
    this.element.classList.toggle('visible');

    if (currentType == 'text') {
      this.element.setAttribute('type','password');
    }
    else {
      this.element.setAttribute('type','text');
    }
  }

  handleVisibility() {
    if (this.element.value == '') {
      this.icoHandler.classList.add('hidden');
    }
    else {
      this.icoHandler.classList.remove('hidden');
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/PasswordToggle.js